import { render, staticRenderFns } from "./ResponsiveLayout.vue?vue&type=template&id=28ae6a18&scoped=true&"
import script from "./ResponsiveLayout.vue?vue&type=script&lang=js&"
export * from "./ResponsiveLayout.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveLayout.vue?vue&type=style&index=0&id=28ae6a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae6a18",
  null
  
)

export default component.exports